/**
 * A stream belongs to a bintu stream group that holds the whole rendition ladder: the unmodified
 * ingest plus its transcodes. The group is reachable for every member of it, so the played stream
 * resolves the same ladder no matter which rendition is being watched.
 *
 * The ladder is delivered as `playout.rtmp`, where only a transcode carries an `info` block with its
 * target format - the passthrough rendition has none.
 */
export function selectRenditions(groupResponse, playedStream) {
   const renditions = groupResponse?.playout?.rtmp;
   if (!Array.isArray(renditions)) return [];

   return [...renditions]
      .sort((a, b) => (a.index ?? 0) - (b.index ?? 0))
      .map((rendition) => ({
         streamname: rendition.streamname ?? '',
         index: rendition.index ?? 0,
         isTranscode: Boolean(rendition.info),
         resolution: rendition.info ? `${rendition.info.width}x${rendition.info.height}` : '',
         bitrate: rendition.info?.bitrate,
         fps: rendition.info?.fps,
         isPlayed: Boolean(playedStream) && rendition.streamname === playedStream,
      }));
}

export function countTranscodes(renditions) {
   return renditions.filter((rendition) => rendition.isTranscode).length;
}
